import { render, staticRenderFns } from "./IssueBooks.vue?vue&type=template&id=077c7904&"
import script from "./IssueBooks.vue?vue&type=script&lang=js&"
export * from "./IssueBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports